import MapLayer from '../map-layer.enum';
import setMaritimeAreasLayer from './maritime-areas-layer';

function addMaritimeAreasLayer() {
  return setMaritimeAreasLayer(MapLayer.RI_MARITIME_AREAS, true);
}

export default addMaritimeAreasLayer;
